module.exports = __webpack_public_path__ + "static/media/Calendarsmall.1e728d9b.png";